<template>
    <div class="article-why">
        <ul>
            <li>
                <strong>Comprehensive Solutions:</strong>
                From cleaning to waste disposal, we cover all aspects of tanker maintenance.
            </li>
            <li>
                <strong>Expert Partnerships:</strong>
                With the expertise of <strong>ZHOUSHAN GOLDEN OCEAN TANKER CLEANING</strong>, we guarantee top-notch
                service delivery.
            </li>
            <li>
                <strong>Sustainability Focus:</strong>
                Our processes are designed to minimise environmental impact.
            </li>
            <li>
                <strong>Proven Track Record:</strong>
                Trusted by industry leaders, we bring professionalism and reliability to every project.
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    name: 'ArticleWhy',
};
</script>
